import React from "react";
import './css/CourseHeaderStyle.css';
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

function HeaderTop() {
    const location = useLocation(); // ✅ React Router hook se location milega

    const titles = {
        "/CSIR-Net-Course": "CSIR NET",
        "/IIT-Gate-Course": "IIT GATE",
        "/IIT-Jam-Course": "IIT JAM", 
        "/TFIR-Course": "TFIR Course",
        "/CUET-PG-Course": "CUET PG Chemistry",
        "/Assistant-professor-Course" : "Assistant Professor",
        "/PGT-Chemistry-Course": "PGT Chemistry",
        "/Geochemist": "UPSC Combined Geoscientist",
        "/Patent-Officer": "Patent Officer",
        "/BARC-Chemistry": "BARC Chemistry",
        "/Pollution-Control-Board": "Pollution Control Board"
    };

    const buttonTextMap = {
        "/Assistant-professor-Course" : "Books",
        "/CSIR-Net-Course": "Books",
        "/IIT-Gate-Course": "Books",
        "/IIT-Jam-Course": "Books", 
        "/TFIR-Course": "Books",
        "/CUET-PG-Course": "Books",
        "/PGT-Chemistry-Course": "Books",
        "/Geochemist": "Books",
        "/Patent-Officer": "Books",
        "/BARC-Chemistry": "Books",
        "/Pollution-Control-Board": "Books"
    }
    const title = titles[location.pathname] || "My Website";
    const buttonText = buttonTextMap[location.pathname] || "Pass";
    return (
            <div className="headerTop">
                <div class="container py-5">
                    <div class="d-flex align-items-center mb-3">
                        <h2 class="fw-bold mb-0">{title}  Previous Year Question Paper PDFs With Solutions </h2>
                    </div>

                    {/* <span class="badge badge-custom mb-3">73+ PYP Tests</span> */}

                    <p class="mb-3"><i class="bi bi-check2 text-white"></i> Also Unlock 35000+ PYP's with VIGYAN VRIKSH MEMBER On Youtube</p>
                    {/* <p class="mb-3">
                        <i class="bi bi-check-circle-fill text-whiet"></i> Also <b>Unlock 35000+ PYP’s</b> with <span class="fw-bold text-white">testbook <span class="badge bg-warning text-dark">PRO</span></span>
                    </p> */}

                    <div class="mb-4">
                        <Link class="btn btn-outline-custom btn-lg me-3">Test Series</Link> 
                        <Link class="btn btn-outline-custom btn-lg">Complete Course</Link><br/><br/>
                        <Link class="btn btn-green btn-lg me-3">Get {buttonText} Pro Now</Link>
                        <Link class="btn btn-outline-custom btn-lg">Question Bank</Link>
                    </div>

                    <p class="text-white"><i class="bi bi-people-fill me-1"></i> <b>37.2k</b> Students Improve their score through VIGYAN VRIKSH</p>

                </div>
            </div>
    );
}

export default HeaderTop;